var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(
			_vm.$store.state.tenantId === 'aeg_uat' ||
				_vm.$store.state.tenantId === 'aeg' ||
				_vm.$store.state.tenantId === 'demo_uat' ||
				_vm.$store.state.tenantId === 'bupa_uat' ||
				_vm.$store.state.tenantId === 'apeiron_uat'
		)?[_c('aeg-policy-list')]:(
			_vm.$store.state.tenantId === 'asia_uat' ||
				_vm.$store.state.tenantId === 'asia' ||
				_vm.$store.state.tenantId === 'aia_uat'
		)?[_c('asia-policy-list')]:(_vm.$store.state.tenantId === 'berkley_uat')?[_c('berkley-policy-list')]:(
			_vm.$store.state.tenantId === 'hkecic_uat' ||
				_vm.$store.state.tenantId === 'hkecic'
		)?[_c('hkecic-policy-list')]:(
			_vm.$store.state.tenantId === 'fiLife_uat' ||
				_vm.$store.state.tenantId === 'fiLife'
		)?[_c('fi-life-policy-list')]:(
			_vm.$store.state.tenantId === 'demo2_uat' ||
				_vm.$store.state.tenantId === 'demo2'
		)?[_c('demo-2-policy-list')]:(
			_vm.$store.state.tenantId === 'zurich_uat' ||
				_vm.$store.state.tenantId === 'zurich'
		)?[_c('zurich-policy-list')]:(
			_vm.$store.state.tenantId === 'digitalBroker' ||
				_vm.$store.state.tenantId === 'companyCover_uat'
		)?[_c('digital-broker-policy-list')]:[_c('default-policy-list')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }